var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgeArchived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21C22.6569 0 24 1.34315 24 3V24H0V0Z",
    fill: "#262626",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 6.9375H5.25C4.93934 6.9375 4.6875 7.18934 4.6875 7.5V9.1875C4.6875 9.49816 4.93934 9.75 5.25 9.75H18.75C19.0607 9.75 19.3125 9.49816 19.3125 9.1875V7.5C19.3125 7.18934 19.0607 6.9375 18.75 6.9375Z",
    stroke: "#333333",
    strokeWidth: 1.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1875 9.75V16.5C18.1875 16.6492 18.1282 16.7923 18.0227 16.8977C17.9173 17.0032 17.7742 17.0625 17.625 17.0625H6.375C6.22582 17.0625 6.08274 17.0032 5.97725 16.8977C5.87176 16.7923 5.8125 16.6492 5.8125 16.5V9.75",
    stroke: "#333333",
    strokeWidth: 1.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 12.5625H13.6875",
    stroke: "#333333",
    strokeWidth: 1.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeArchived);
export default __webpack_public_path__ + "static/media/badge-archived.6bfa575e005cf1f6c4c2f8ba7b3895b8.svg";
export { ForwardRef as ReactComponent };